export const _SUCCESS = "_SUCCESS";
export const _FAILURE = "_FAILURE";
export const FETCH_CITIES_REQUEST = "FETCH_CITIES_REQUEST";
export const CHANGE_CITY_STATUS_REQUEST = "CHANGE_CITY_STATUS_REQUEST";
export const UPDATE_CITY_REQUEST = "UPDATE_CITY_REQUEST";
export const CREATE_CITY_REQUEST = "CREATE_CITY_REQUEST";
export const CHANGE_CITY_WEIGHT_REQUEST = "CHANGE_CITY_WEIGHT_REQUEST";
